import { render, staticRenderFns } from "./fold2.vue?vue&type=template&id=009b46ae&scoped=true&"
import script from "./fold2.vue?vue&type=script&lang=js&"
export * from "./fold2.vue?vue&type=script&lang=js&"
import style0 from "./fold2.vue?vue&type=style&index=0&id=009b46ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "009b46ae",
  null
  
)

export default component.exports